import type { Course } from '@/lib/db/types';

const TEST_COURSE_RE = /(^test[-_\s]|[-_\s]test$|\btest\s+course\b|\bdemo\s+course\b|^demo[-_])/i;

/** Hide seed/dev courses from pickers while leaving real Arlington/Fairfax data intact. */
export function isTestCourse(course: Pick<Course, 'slug' | 'name'>): boolean {
  return TEST_COURSE_RE.test(course.slug) || TEST_COURSE_RE.test(course.name);
}

export function filterProductionCourses(courses: Course[]): Course[] {
  return courses.filter((c) => !isTestCourse(c));
}
